import { useTranslation } from "react-i18next";
import { useGlobal } from "../../../context/GlobalContext";
import { useEffect, useRef } from "react";
import SvgReload from "../../icons/svg/SvgReload";
import { useLocation, useNavigate, useNavigation } from "react-router-dom";


const SearchBar = () =>{
    const { t } = useTranslation();
    const { g } = useGlobal();
    const refInputSearch = useRef();
    const location = useLocation();
    const navigate = useNavigate();

    // Ресет пошуку
    const handleReset = () => {
        //navigate('/pages');
        refInputSearch.current.value = ''
        g.setSearch((prev)=>({
            ...prev,
            [location.pathname] : null
        }));
        g.setTarget(!g.target); 
    }  

    // Пошук
    const handleSubmitSearch = (e) => {
        //navigate('/pages');
        e.preventDefault();
        g.setSearch((prev)=>({
            ...prev,
            [location.pathname] : refInputSearch?.current?.value?.trim()||''
        }));
        
    } 

    useEffect(()=>{
        refInputSearch.current.value = g.search?.[location.pathname]||'' ;
    }, [g.search, location.pathname]) 
 
  
    return (
        <div className="pc-h-item d-none d-sm-inline-flex">
            <form className="form-search"
                onSubmit={(e)=>handleSubmitSearch(e)}>
                <i className="bi bi-search"
                    style={{
                        lineHeight: '35px',
                        fontSize: '16px'
                    }}></i>
                <input type="text" 

                    ref={refInputSearch}
                    defaultValue={g?.search||''}
                    className="form-control" 
                    placeholder={t('SearchBar.placeHolder')}/>
            </form>
            <div className="ms-1">
            <span
                className="avtar cursor-pointer btn-sm btn-link-secondary"
                    onClick={()=>handleReset()}><SvgReload/></span>
            </div>
        </div>
    )
}
 
export default SearchBar;